class AccordionItem extends HTMLElement {
  connectedCallback() {
    this.details = this.querySelector("details");
    this.content = this.querySelector(".accordion-content");
    this.summary = this.querySelector("summary");
    if (!this.details || !this.content || !this.summary) return;
    this.summary.addEventListener("click", (e) => {
      e.preventDefault();
      this.toggle();
    });
  }
  toggle() {
    if (this.details.open) {
      this.close();
    } else {
      this.open();
    }
  }
  open() {
    this.details.open = true;
    const h = this.content.scrollHeight;
    this.content.style.height = "0px";
    requestAnimationFrame(() => {
      this.content.style.height = h + "px";
    });
    this.content.addEventListener("transitionend", () => {
      this.content.style.height = "";
    }, { once: true });
  }
  close() {
    this.content.style.height = this.content.scrollHeight + "px";
    requestAnimationFrame(() => {
      this.content.style.height = "0px";
    });
    this.content.addEventListener("transitionend", () => {
      this.details.open = false;
      this.content.style.height = "";
    }, { once: true });
  }
}
customElements.define("accordion-item", AccordionItem);
